import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import CustomTabs from "../../../../components/app/CustomTabs";
import PatientSectionWrapper from "../PatientSectionWrapper";
import StyledButtonV2 from "../../../../components/app/StyledButtonV2";
import { UploadFileOutlined } from "@mui/icons-material";

const PatientDocuments = () => {
  const navigate = useNavigate();

  const tabsData = [
    {
      label: "Incomplete",
      value: "",
    },
    {
      label: "Completed",
      value: "completed",
    },
  ];
  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "documents" ? "" : (currentTab as string);
  });

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(tab);
  };

  return (
    <PatientSectionWrapper
      header={
        <CustomTabs
          tabsData={tabsData}
          value={activeTab}
          onChange={handleTabChange}
        />
      }
      endAction={
        activeTab == "" ? (
          <StyledButtonV2
            sIcon={<UploadFileOutlined />}
            label="Upload Document"
            variant="contained"
            color="primary"
          />
        ) : null
      }
    >
      <Outlet />
    </PatientSectionWrapper>
  );
};

export default PatientDocuments;
